/**
 * CW - Cart drawer opened flag (general script, runs for ALL visitors)
 *
 * Sets window.cwCartOpened = true the first time the cart drawer becomes visible
 * (click on the cart icon or auto-open after Add to cart).
 * Intelligems targeting condition (Custom > Javascript > evaluates to true):
 *   window.cwCartOpened == true
 */
(function () {
  'use strict';

  function isDrawerOpen() {
    var drawer = document.querySelector('#shopify-section-ajaxcart .my-cart');
    if (!drawer) return false;
    var cs = getComputedStyle(drawer);
    var r = drawer.getBoundingClientRect();
    return cs.display !== 'none' &&
           cs.visibility !== 'hidden' &&
           r.width > 0 &&
           r.right > 0 &&
           r.left < window.innerWidth;
  }

  function check() {
    if (window.cwCartOpened || !isDrawerOpen()) return;
    window.cwCartOpened = true;
    document.dispatchEvent(new CustomEvent('cw:cart-opened'));
    console.log('CART OPENED - CW TEST STARTING');
  }

  new MutationObserver(check).observe(document.body, {
    childList: true,
    subtree: true,
    attributes: true,
    attributeFilter: ['class', 'style', 'aria-hidden']
  });
  document.addEventListener('transitionend', check, true);
})();